import {
  SHOW_SETTINGS_SIDE_MENU, HIDE_SETTINGS_SIDE_MENU
} from '../actions/actionTypes.jsx';
import { combineReducers } from 'redux';
// import { streamAccessControlReducer } from './streamAccessControlReducer';
import { userGroupReducer } from './userGroupReducer';
import { customFieldReducer } from './customFieldReducer';
import { emailTemplateReducer } from './emailTemplateReducer';
import { ndaTemplateReducer } from './ndaTemplateReducer';
import { integrationsReducer } from './integrationsReducer';
import { userManagementReducer } from './userManagementReducer';

const initialState = {
  showSettingsMenu: true
}

function settingsMenuReducer(state = initialState, action) {
  switch (action.type) {
    case SHOW_SETTINGS_SIDE_MENU:
      return Object.assign({}, state, {
        showSettingsMenu: true
      })
    case HIDE_SETTINGS_SIDE_MENU:
      return Object.assign({}, state, {
        showSettingsMenu: false
      })

    default:
      return state
  }
}

const settingsReducer = combineReducers({
  // streamAccessControl: streamAccessControlReducer,
  settingsMenu: settingsMenuReducer,
  userManagement: userManagementReducer,
  // dataSources: dataSourceReducer, 
  integrations: integrationsReducer,
  emailTemplate: emailTemplateReducer,
  userGroup: userGroupReducer,
  ndaTemplates: ndaTemplateReducer,
  customFields: customFieldReducer,
});

export { settingsReducer };